export const Products = {
  VoucherRestaurant: 'voucher-restaurant',
  VoucherRecreational: 'voucher-recreational'
};
